import { Link } from 'react-router-dom';
import { LANDINGS } from './landings/registry';

// Deliberately kept in the main bundle: it is tiny, and it is what an unknown
// URL falls back to, so it should render without a second round trip.
export default function Home() {
  return (
    <main className="font-bn min-h-screen bg-walnut-50 px-4 py-16 text-walnut-800">
      <div className="mx-auto max-w-2xl">
        <header className="mb-10 text-center">
          <h1 className="text-3xl font-bold text-walnut-900">কাঠের মেলা</h1>
          <p className="mt-2 text-walnut-600">ল্যান্ডিং পেজ সমূহ</p>
          <div className="mx-auto mt-3 h-1 w-16 rounded-full bg-clay-500/70" />
        </header>

        <ul className="space-y-3">
          {LANDINGS.map((l) => (
            <li key={l.slug}>
              <Link
                to={`/landing/${l.slug}`}
                className="flex items-center justify-between gap-4 rounded-2xl border border-walnut-200
                           bg-white p-5 shadow-card transition hover:border-clay-500 hover:shadow-lift"
              >
                <span className="min-w-0">
                  <span className="block font-bold text-walnut-900">{l.title}</span>
                  <span className="mt-0.5 block text-sm text-walnut-600">{l.blurb}</span>
                  <span className="mt-1 block font-mono text-xs text-walnut-400">
                    /landing/{l.slug}
                  </span>
                </span>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                     strokeLinecap="round" strokeLinejoin="round"
                     className="h-5 w-5 shrink-0 text-clay-500" aria-hidden="true">
                  <path d="m9 18 6-6-6-6" />
                </svg>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </main>
  );
}
